import React, { useContext, useEffect, useState } from "react";
import { Fragment } from "react";
import { Disclosure, Menu, Transition } from "@headlessui/react";
import {
  Bars3Icon,
  PlusCircleIcon,
  XMarkIcon,
} from "@heroicons/react/24/outline";
import { IoIosArrowDown, IoIosMail } from "react-icons/io";
import { FaLinkedin } from "react-icons/fa";
import {
  FaFacebook,
  FaInstagram,
  FaPhoneSquareAlt,
  FaTwitter,
} from "react-icons/fa";
import { Row, Col } from "antd";
import { Link, useLocation, useNavigate } from "react-router-dom";
import dummyuser from "../../assets/frontendassets/dummyuser.png";
import { AuthContext } from "../Auth/AuthContext";

function classNames(...classes: any) {
  return classes.filter(Boolean).join(" ");
}

const navigation = [
  { name: "ABOUT US", href: "/about-us", current: false, dropdownItems: [] },
  { name: "EXPLORE LISTINGS", href: "/explore-listing", current: false, dropdownItems: [] },
  { name: "BLOGS", href: "/blogs", current: false, dropdownItems: [] },
  { name: "CONTACT US", href: "/contact-us", current: false, dropdownItems: [] },
];

const HeaderUser = () => {
  const logo = require("../../assets/frontendassets/Logos/final net4surge logo2.png");
  const HeaderImage = require("../../assets/frontendassets/commanHeaderImage.png");
  const explore  = require("../../assets/frontendassets/main exlpore listing.png");
  const blogs  = require("../../assets/frontendassets/main blogs.png");
  const contactus  = require("../../assets/frontendassets/main contact us.png");
  const mybuines  = require("../../assets/frontendassets/my business.png");
  const [profileImageUrl, setProfileImageUrl] = useState("");
  const { authData, setAuthData } = useContext(AuthContext);
  const token = authData.token;
  const location = useLocation();
  const navigate = useNavigate();
  const currentPath = location.pathname;

  const handleLogout = () => {
    localStorage.clear();
    setAuthData({
      token: null, user: null,
      roleId: undefined
    });
    navigate("/login");
  };


  const profileImage = () => {
    return authData?.user?.image
      ? `${process.env.REACT_APP_IMAGE_URL}/users/${authData?.user?.image}`
      : "";
  };

  useEffect(() => {
    setProfileImageUrl(profileImage());
  }, [authData]);


  // const navigate = useNavigate();

  const handleAddListingClick = () => {
    localStorage.setItem("redirectAfterLogin", "/add-listing"); // Store last visited route
    localStorage.clear();
    navigate("/login", { state: { from: "/add-listing" } }); // Always redirect to login
    
  };

  return (
    <>
       <Disclosure
        as="nav"
        className={`bg-[#FFF8EC] md:ps-0 md:px-0 xl:pt-0 fixed z-50 left-0 right-0 ${currentPath === "/contact-us" || currentPath === "/about-us" || currentPath === "/blogs" ? "bg-[#FFF8EC]" : "none"} w-full`}
      >
        {({ open, close }) => (
          <>
            <div className="max-w-100 px-2">
              <div className="relative flex h-24 items-center justify-between p-4">
                <div className="flex items-center">
                  <div className="flex flex-shrink-0 items-center">
                    <Link to="/">
                      <img
                        className="h-12 md:h-20 lg:h-24 bg-none"
                        src={logo}
                        alt="Your Company"
                      />
                    </Link>
                  </div>
                </div>
                <div className="absolute inset-y-0 right-0 flex justify-center items-center pr-2 sm:static sm:inset-auto sm:pr-0">
                  <div className="hidden sm:ml-6 xl:flex xxl:flex">
                    <div className="flex space-x-4">
                      {navigation.map((item) => (
                        <div key={item.name} className="relative">
                          {item.dropdownItems.length > 0 ? (
                            <Menu as="div" className="relative">
                              <Menu.Button
                                className="relative flex items-center justify-center rounded-md text-lg"
                                style={{ color: "#838383" }}
                              >
                                <span style={{ paddingTop: "2px" }}>{item.name}</span>
                                <IoIosArrowDown
                                  className="ml-1 h-2 w-3"
                                  aria-hidden="true"
                                  style={{ color: "#838383", marginTop: "5px" }}
                                />
                              </Menu.Button>
                              <Transition
                                as={Fragment}
                                enter="transition ease-out duration-100"
                                enterFrom="transform opacity-0 scale-95"
                                enterTo="transform opacity-100 scale-100"
                                leave="transition ease-in duration-75"
                                leaveFrom="transform opacity-100 scale-100"
                                leaveTo="transform opacity-0 scale-95"
                              >
                                <Menu.Items className="absolute right-0 z-10 mt-2 w-48 origin-top-right rounded-md bg-white py-1 shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                                  {item.dropdownItems.map((dropdownItem) => (
                                    <Menu.Item key={dropdownItem}>
                                      {({ active }) => (
                                        <Link
                                          to={item.href}
                                          className={classNames(
                                            active ? "bg-gray-100 text-black w-full" : "",
                                            "block w-full px-4 py-2 text-base text-black"
                                          )}
                                        >
                                          {dropdownItem}
                                        </Link>
                                      )}
                                    </Menu.Item>
                                  ))}
                                </Menu.Items>
                              </Transition>
                            </Menu>
                          ) : (
                            <Link
                              to={item.href}
                              className={classNames(
                                "px-3 py-2 text-[16px] text-semibold text-black"
                              )}
                              style={currentPath === item.href ? { color: "#6B7280" } : {}}
                              aria-current={currentPath === item.href ? "page" : undefined}
                            >
                              {item.name}
                            </Link>
                          )}
                        </div>
                      ))}
                    </div>
                  </div>

                    <Disclosure.Button className="relative inline-flex items-center xl:hidden justify-center rounded-md p-2 text-gray-400 hover:bg-gray-700 hover:text-white focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white">
                      <span className="absolute -inset-0.5" />
                      <span className="sr-only">Open main menu</span>
                      {open ? (
                        <XMarkIcon className="block h-6 w-6" aria-hidden="true" />
                      ) : (
                        <Bars3Icon className="block h-6 w-6" aria-hidden="true" />
                      )}
                    </Disclosure.Button>
                </div>
                <div className="hidden xl:flex xxl:flex items-center">
                  <Menu as="div" className="relative ml-3 mr-3">
                    <div>
                      <Menu.Button className="relative flex rounded-full bg-gray-800 text-sm focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-gray-800">
                        <span className="absolute -inset-1.5" />
                        <span className="sr-only">Open user menu</span>
                        <img
                          className="h-8 w-8 rounded-full"
                          src={profileImageUrl || dummyuser}
                          alt="User Profile"
                        />
                      </Menu.Button>
                    </div>
                    <Transition
                      as={Fragment}
                      enter="transition ease-out duration-100"
                      enterFrom="transform opacity-0 scale-95"
                      enterTo="transform opacity-100 scale-100"
                      leave="transition ease-in duration-75"
                      leaveFrom="transform opacity-100 scale-100"
                      leaveTo="transform opacity-0 scale-95"
                    >
                      <Menu.Items className="absolute right-0 z-10 mt-2 w-48 origin-top-right rounded-md bg-white py-1 shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                        {token ? (
                          <>
                            <Menu.Item>
                              {({ active }) => (
                                <Link
                                  to="/backend/profile"
                                  className={classNames(
                                    active ? "bg-gray-100" : "",
                                    "block px-4 py-2 text-sm text-gray-700"
                                  )}
                                >
                                  Your Profile
                                </Link>
                              )}
                            </Menu.Item>
                            <Menu.Item>
                              {({ active }) => (
                                <Link
                                  to="/my-listing"
                                  className={classNames(
                                    active ? "bg-gray-100" : "",
                                    "block px-4 py-2 text-sm text-gray-700"
                                  )}
                                >
                                  My Businesses
                                </Link>
                              )}
                            </Menu.Item>
                            <Menu.Item>
                              {({ active }) => (
                                <Link
                                  to="/login"
                                  onClick={handleLogout}
                                  className={classNames(
                                    active ? "bg-gray-100" : "",
                                    "block px-4 py-2 text-sm text-gray-700"
                                  )}
                                >
                                  Sign out
                                </Link>
                              )}
                            </Menu.Item>
                          </>
                        ) : (
                          <>
                            <Menu.Item>
                              {({ active }) => (
                                <Link
                                  to="/login"
                                  className={classNames(
                                    active ? "bg-gray-100" : "",
                                    "block px-4 py-2 text-sm text-gray-700"
                                  )}
                                >
                                  Login
                                </Link>
                              )}
                            </Menu.Item>
                          </>
                        )}
                      </Menu.Items>
                    </Transition>
                  </Menu>

                  <div className="hidden xl:flex xxl:flex rounded-lg">
                    <PlusCircleIcon
                      className="h-auto w-10 bg-[#F9B138] rounded-tl-md rounded-bl-md p-1"
                      aria-hidden="true"
                      color="black"
                    />
                    {/* <Link to="/add-listing"> */}
                      <button
                        type="button"
                        onClick={handleAddListingClick}
                        className="bg-[#FFE8C2] rounded-none rounded-tr-md rounded-br-md btn btn-lg text-black align-items-center"
                      >
                        <span className="ext-white uppercase">Add Listing</span>
                      </button>
                    {/* </Link> */}
                  </div>
                </div>
              </div>
            </div>

            {/* Mobile Menu */}
            <Disclosure.Panel className="sm:block md:block">
              <div className="space-y-1 px-2 pb-3 pt-2">
                {navigation.map((item) => (
                  <div key={item.name} className="w-full">
                    {item.dropdownItems.length > 0 ? (
                      <Disclosure>
                        {({ open }) => (
                          <>
                            <Disclosure.Button
                              as="div"
                              className={classNames(
                                item.current ? "bg-gray-100 w-full" : "w-full",
                                "px-4 py-2 text-xs text-gray-700 flex justify-start w-full"
                              )}
                              aria-current={item.current ? "page" : undefined}
                            >
                              <Link
                                className="w-full"
                                to={item.href}
                                onClick={()=> close()} // Close the menu when clicked
                              >
                                {item.name}
                              </Link>
                              <IoIosArrowDown
                                className="ml-1 h-2 w-3 mt-2"
                                aria-hidden="true"
                                style={{ color: "#838383" }}
                              />
                            </Disclosure.Button>
                            <Transition
                              show={open}
                              enter="transition ease-out duration-100"
                              enterFrom="transform opacity-0 scale-95"
                              enterTo="transform opacity-100 scale-100"
                              leave="transition ease-in duration-75"
                              leaveFrom="transform opacity-100 scale-100"
                              leaveTo="transform opacity-0 scale-95"
                            >
                              <Disclosure.Panel>
                                <div className="pl-2 space-y-1">
                                  {item.dropdownItems.map((dropdownItem) => (
                                    <Link
                                      key={dropdownItem}
                                      to={dropdownItem}
                                      className={classNames(
                                        "block px-4 py-2 text-sm text-gray-700 w-full",
                                        "hover:bg-gray-100 hover:text-yellow-700 w-full"
                                      )}
                                      onClick={()=> close()} // Close the menu when clicked
                                    >
                                      {dropdownItem}
                                    </Link>
                                  ))}
                                </div>
                              </Disclosure.Panel>
                            </Transition>
                          </>
                        )}
                      </Disclosure>
                    ) : (
                      <Disclosure.Button
                        className={classNames(
                          item.current ? "bg-gray-100" : "",
                          "block px-4 py-2 text-sm text-gray-700"
                        )}
                        aria-current={item.current ? "page" : undefined}
                      >
                        <Link
                          to={item.href || "/"}
                          onClick={()=> close()} // Close the menu when clicked
                        >
                          {item.name}
                        </Link>
                      </Disclosure.Button>
                    )}
                  </div>
                ))}

                {/* Add the "Login" and "Add Listing" buttons in mobile view */}
                <div className="mt-4">
                  {token ? (
                    <>
                      <Link
                        to="/backend/profile"
                        className="block text-[16px] w-full px-4 py-2 text-sm text-start text-gray-700 bg-[#FFF8EC] hover:bg-gray-200 rounded-md"
                        onClick={()=> close()} // Close the menu when clicked
                      >
                        Your Profile
                      </Link>
                      <Link
                        to="/my-listing"
                        className="block w-full px-4 py-2 text-sm text-start text-gray-700 bg-bg-[#FFF8EC] hover:bg-gray-200 rounded-md"
                        onClick={()=> close()} // Close the menu when clicked
                      >
                        My Businesses
                      </Link>
                      <button
                        onClick={() => {
                          handleLogout();
                          close(); // Close the menu when clicked
                        }}
                        className="block w-full px-4 py-2 text-sm text-start text-gray-700 bg-bg-[#FFF8EC] hover:bg-gray-200 rounded-md"
                      >
                        Logout
                      </button>
                    </>
                  ) : (
                    <Link
                      to="/login"
                      className="block w-full px-4 py-2 text-sm text-center font-bold text-gray-700 bg-gray-100 hover:bg-gray-200 rounded-md"
                      onClick={()=> close()} // Close the menu when clicked
                    >
                      Login
                    </Link>
                  )}
                </div>

                <div className="mt-4">
                  <button
                    
                    className="block w-full px-4 py-2 text-sm text-center font-bold text-white bg-[#F9B138] hover:bg-yellow-500 rounded-md"
                    onClick={() => {
                      close();
                      handleAddListingClick();
                    }}
                    
                  >
                    Add Listing
                  </button>
                </div>
              </div>
            </Disclosure.Panel>
          </>
        )}
      </Disclosure>

      {
  currentPath === "/contact-us" ? (
    // Render content for "/contact-us"
    <div className="relative pt-20">
    {/* Image */}
    <img
      src={contactus}
      alt="Contact Us"
      className="shadow-inner shadow-slate-700 drop-shadow-xl h-[300px] sm:h-[300px] lg:h-[400px] w-full object-cover"
    />
  
    {/* Gradient Overlay */}
    <div
      className="absolute inset-0"
      style={{
        background: "linear-gradient(to bottom, rgba(45, 45, 50, 0) 50%, rgba(0, 0, 0, 0.6) 80%,  rgba(93, 93, 83, 0.9) 100%)",
      }}
    ></div>
  
    {/* Text */}
    <p className="text-[25px] sm:text[45px] md:text-[55px] lg:text-[65px] border-4 border-white lg:p-3 p-2 font-bold text-white absolute top-[60%] left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-10 uppercase">
      Contact Us
    </p>
  </div>
  
  ) : currentPath === "/about-us" ? (
    // Render content for "/about-us"
<div className="relative pt-20 shadow-inner shadow-neutral-900">
  {/* Image */}
  <img
    src={HeaderImage}
    alt="Blogs"
    className="shadow-inner shadow-slate-700 drop-shadow-xl h-[300px] sm:h-[300px] lg:h-[400px] w-full object-cover"
  />

  {/* Gradient Overlay */}
  <div
    className="absolute inset-0"
    style={{
      background: "linear-gradient(to bottom, rgba(45, 45, 50, 0) 50%, rgba(0, 0, 0, 0.6) 80%,  rgba(93, 93, 83, 0.9) 100%)", // Further reduced the opacity at the top and darkened the bottom
    }}
  ></div>

  {/* Text */}
  <p className="text-[25px] sm:text[45px] md:text-[55px] lg:text-[65px]  border-4 border-white lg:p-3 p-2 font-bold text-white absolute top-[60%] left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-10 uppercase">
    About Us
  </p>
</div>


  


  
  
  ) : currentPath === "/blogs" ? (
    // Render content for "/blogs"  
    <div className="relative pt-20">
    {/* Image */}
    <img
      src={blogs}
      alt="Blogs"
      className="shadow-inner shadow-slate-700 drop-shadow-xl h-[300px] sm:h-[300px] lg:h-[400px] w-full object-cover"
    />
  
    {/* Gradient Overlay */}
    <div
      className="absolute inset-0"
      style={{
        background: "linear-gradient(to bottom, rgba(45, 45, 50, 0) 50%, rgba(0, 0, 0, 0.6) 80%,  rgba(128, 128, 128, 0.9) 100%)",
      }}
    ></div>
  
    {/* Text */}
    <p className="text-[25px] sm:text[45px] md:text-[55px] lg:text-[65px]  border-4 border-white lg:p-3 p-2 font-bold text-white absolute top-[60%] left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-10 uppercase">
      Blogs
    </p>
  </div>
  
  ) : currentPath === "/explore-listing" ? (
    <>
   <div className="relative pt-20 shadow-inner shadow-neutral-900">
  {/* Image */}
  <img
    src={explore}
    alt="Blogs"
    className="shadow-inner shadow-slate-700 drop-shadow-xl h-[300px] sm:h-[300px] lg:h-[400px] w-full object-cover"
  />

  {/* Gradient Overlay */}
  <div
    className="absolute inset-0"
    style={{
      background: "linear-gradient(to bottom, rgba(45, 45, 50, 0) 50%, rgba(0, 0, 0, 0.6) 80%,  rgba(128, 128, 128, 0.9) 100%)",
    }}
  ></div>

  {/* Text */}
  <p className="text-[18px] sm:text[45px] md:text-[38px] lg:text-[65px]  border-4 border-white lg:p-3 p-2 font-bold text-white absolute top-[60%] left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-10 uppercase">
    Explore Listing
  </p>
</div>


    </>
  ) : currentPath === "/my-listing" ? (
    <>
   <div className="relative pt-20">
  {/* Image */}
  <img
    src={mybuines}
    alt="My Business"
    className="shadow-inner shadow-slate-700 drop-shadow-xl h-[300px] sm:h-[300px] lg:h-[400px] w-full object-cover"
  />

  {/* Gradient Overlay */}
  <div
    className="absolute inset-0"
    style={{
      background: "linear-gradient(to bottom, rgba(45, 45, 50, 0) 50%, rgba(0, 0, 0, 0.6) 80%,  rgba(128, 128, 128, 0.9) 100%)",
    }}
  ></div>

  {/* Text */}
  <p className="text-[25px] sm:text[45px] md:text-[55px] lg:text-[65px]  border-4 border-white  lg:p-3 p-2 font-bold text-white absolute top-[60%] left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-10 uppercase">
    My Business
  </p>
</div>

    </>
  )  : currentPath === "/listing" ? (
    <>
   <div className="relative pt-20">
  {/* Image */}
  </div>

    </>
  )  
  
  : (
  null
  )
}

    </>
  );
};

export default HeaderUser;
